export enum TooltipPosition {
  Top = "Top",
  TopStart = "TopStart",
  TopEnd = "TopEnd",
  Right = "Right",
  RightStart = "RightStart",
  RightEnd = "RightEnd",
  Bottom = "Bottom",
  BottomStart = "BottomStart",
  BottomEnd = "BottomEnd",
  Left = "Left",
  LeftStart = "LeftStart",
  LeftEnd = "LeftEnd",
}

export enum TooltipSize {
  XS = "Xs",
  S = "S",
  M = "M",
}
